import { memo, useMemo } from "react";
import { Link } from "react-router-dom";

import "./ft.css";

const SERVER_BASE_URL = "https://admin.monsinidress.com";
const DEMO_IMAGE_BASE_URL = "https://demo.riskydress.com/images/2026";

function getImageUrl(imagePath) {
	if (!imagePath) return "";
	if (/^https?:\/\//i.test(imagePath)) return imagePath;

	return `${SERVER_BASE_URL}/${String(imagePath).replace(/^\/+/, "")}`;
}

function getDemoImageFolder(type) {
	if (type === "bridal") return "ENCHANTED-B";
	if (type === "evening") return "ENCHANTED-E";
	return "MONSINI";
}

function Featurelist({ data, count, show = "yes" }) {
	const imageUrl = useMemo(
		() => getImageUrl(data?.images?.[0]),
		[data?.images]
	);

	const productUrl = useMemo(
		() => `/product/id/${encodeURIComponent(data?.style || "")}`,
		[data?.style]
	);

	const linkState = useMemo(
		() => ({
			product: data,
			url: `${DEMO_IMAGE_BASE_URL}/${getDemoImageFolder(data?.type)}/`,
		}),
		[data]
	);

	if (!data) return null;

	return (
		<li
			className={
				count === 1
					? "block gap-5 md:flex lg:w-10/12"
					: "w-full"
			}
		>
			<div className={count === 1 ? "shrink-0" : "w-full"}>
				<Link to={productUrl} state={linkState}>
					<div
						className={`relative overflow-hidden bg-gray-100 ${
							count === 1
								? "w-full md:h-[400px] md:w-[300px] lg:h-[400px] lg:w-[300px]"
								: "aspect-[4/5] w-full"
						}`}
					>
						{imageUrl ? (
							<img
								src={imageUrl}
								alt={`Monsini style ${data.style || "dress"}`}
								className="myimg h-full w-full object-cover object-top"
								loading="lazy"
								decoding="async"
								fetchPriority="low"
								width="520"
								height="650"
							/>
						) : (
							<div className="flex h-full w-full items-center justify-center text-sm text-gray-400">
								Image unavailable
							</div>
						)}
					</div>
				</Link>
			</div>

			<div>
				{show === "yes" && (
					<p className="mt-3 font-lora font-Jost-Medium">{data.style}</p>
				)}

				{count === 1 && (
					<>
						<p className="hidden py-4 font-Jost-Regular text-textlight md:block">
							FABRIC: Soft Slub Khaddar Includes: Shirt Color: Tie dye
							Size: Chart Attached Fit: Regular Fit...
						</p>
						<button
							type="button"
							className="hidden rounded-md border-2 border-black bg-inherit px-5 py-2 font-Jost-Regular text-black hover:bg-black hover:text-white md:block"
						>
							Select option
						</button>
					</>
				)}
			</div>
		</li>
	);
}

export default memo(Featurelist);
